/**
 * Created by Vadym Yatsyuk on 27/02/16
 */

export default class Weapon {
  constructor(name = '', damage = 5) {
    this.name = name;
    this.damage = damage;
  }
}


// WEBPACK FOOTER //
// ./Entities/Weapon.js